import { GeneralStyle } from '@website-builder/model/style/general-style';

export class GalleryOverlay {
  mode = 'cover';
  overlayOnHover = false;
  animateBackgroundOnly = false;
  style = '';
  padding = '';
  position = 'uk-position-center';
  margin = '';
  maxWidth = '';
  transition = 'uk-transition-fade';

  static normalize(styles: Partial<GalleryOverlay>): GalleryOverlay {
    const generalStyle: GeneralStyle = GeneralStyle.normalize(styles);
    const pureStyles = new GalleryOverlay();

    Object.assign(pureStyles, generalStyle);

    pureStyles.mode = styles.mode ?? pureStyles.mode;
    pureStyles.overlayOnHover = styles.overlayOnHover ?? pureStyles.overlayOnHover;
    pureStyles.animateBackgroundOnly = styles.animateBackgroundOnly ?? pureStyles.animateBackgroundOnly;
    pureStyles.style = styles.style ?? pureStyles.style;
    pureStyles.padding = styles.padding ?? pureStyles.padding;
    pureStyles.position = styles.position ?? pureStyles.position;
    pureStyles.margin = styles.margin ?? pureStyles.margin;
    pureStyles.maxWidth = styles.maxWidth ?? pureStyles.maxWidth;
    pureStyles.transition = styles.transition ?? pureStyles.transition;

    return pureStyles;
  }
}
